// extracted by mini-css-extract-plugin
module.exports = {"section":"K1_section__uAZ2N"};